import { render, staticRenderFns } from "./GroupBookingEdit.vue?vue&type=template&id=4de58253&scoped=true&"
import script from "./GroupBookingEdit.vue?vue&type=script&lang=js&"
export * from "./GroupBookingEdit.vue?vue&type=script&lang=js&"
import style0 from "./GroupBookingEdit.vue?vue&type=style&index=0&id=4de58253&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de58253",
  null
  
)

export default component.exports